import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GonvarriCartOutlets } from '../../core/models/gonvarri-cart-outlets.model';
import {
    CartBaseComponentsModule,
    CartCouponModule,
    CartSharedModule,
    CartValidationWarningsModule
} from '@spartacus/cart/base/components';
import {CmsConfig, FeaturesConfigModule, I18nModule, provideConfig, UrlModule} from '@spartacus/core';
import {
  AtMessageModule,
  IconModule,
  ItemCounterModule,
  MediaModule,
  MessageComponentModule,
  OutletModule,
  PromotionsModule,
  SpinnerModule
} from '@spartacus/storefront';
import { GonvarriCartDetailsComponent } from 'src/app/components/gonvarri-cart-details/gonvarri-cart-details.component';
import { GonvarriCartItemListRowComponent } from 'src/app/components/gonvarri-cart-item-list-row/gonvarri-cart-item-list-row.component';
import { GonvarriCartItemListComponent } from 'src/app/components/gonvarri-cart-item-list/gonvarri-cart-item-list.component';
import { GonvarriAddToCartModule } from '../gonvarri-add-to-cart/gonvarri-add-to-cart.module';
import { GonvarriCartItemValidationWarningComponent } from 'src/app/components/gonvarri-cart-item-validation-warning/gonvarri-cart-item-validation-warning.component';
import { GonvarriChapaQuantityModule } from "../gonvarri-chapa-quantity/gonvarri-chapa-quantity.module";
import { GonvarriQuoteItemsComponent } from '../../components/gonvarri-quote-items/gonvarri-quote-items.component';
import { GonvarriQuoteSummaryActionsComponent } from '../../components/gonvarri-quote-summary-actions/gonvarri-quote-summary-actions.component';
import { GonvarriQuoteSummaryComponent } from '../../components/gonvarri-quote-summary/gonvarri-quote-summary.component';
import {CartPersistenceModule} from "@spartacus/cart/base/core";
import { GonvarriSavedCartDetailsItemsComponent } from '../../components/gonvarri-saved-cart-details-items/gonvarri-saved-cart-details-items.component';
import {
    GonvarriProductQuoteDiscountModule
} from "../gonvarri-product-quote-discount/gonvarri-product-quote-discount.module";

@NgModule({
  declarations: [
    GonvarriCartItemListComponent,
    GonvarriCartDetailsComponent,
    GonvarriCartItemListRowComponent,
    GonvarriCartItemValidationWarningComponent,
    GonvarriSavedCartDetailsItemsComponent
  ],
    imports: [
        I18nModule,
        CommonModule,
        CartCouponModule,
        RouterModule,
        UrlModule,
        PromotionsModule,
        CartValidationWarningsModule,
        OutletModule,
        MediaModule,
        ItemCounterModule,
        AtMessageModule,
        GonvarriAddToCartModule,
        IconModule,
        CartPersistenceModule,
        GonvarriChapaQuantityModule,
        SpinnerModule,
        FeaturesConfigModule,
        MessageComponentModule,
        GonvarriProductQuoteDiscountModule,
    ],
  exports: [
    GonvarriCartItemListComponent,
    GonvarriCartDetailsComponent,
    GonvarriCartItemValidationWarningComponent
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GonvarriCartItemListComponent: {
          component: GonvarriCartItemListComponent
        },
        CartItemListComponent: {
          component: GonvarriCartItemListComponent
        },
        GonvarriCartDetailsComponent: {
          component: GonvarriCartDetailsComponent
        },
        CartComponent: {
          component: GonvarriCartDetailsComponent
        },
        GonvarriCartItemValidationWarningComponent: {
          component: GonvarriCartItemValidationWarningComponent
        },
        SavedCartDetailsItemsComponent: {
          component: GonvarriSavedCartDetailsItemsComponent
        }
      }
    })
  ]
})
export class GonvarriCartSharedModule { }
